import React from "react";
import { MessageTable } from "../..";
import Dashboard_Header from "./Dashboard_Header";
import ToDoList from "./ToDoList";
import { useSelector } from "react-redux";
import Cal from "./Cal";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const userRole = useSelector((state) => state.user.userDetails?.role);
  const location = useLocation();
  const reminderFromNotification = location.state?.reminder;
  return (
    <>
      <div className="flex bg-slate-100/70">
        {/* Main Content */}
        <div
          className={`flex-1 bg-gradient-to-br from-slate-50 via-white to-indigo-50/40 ${
            isSideBarOpen ? "ml-80" : "ml-0 md:ml-20"
          } min-h-screen`}
        >
          {/* Header Section */}
          <div className="sticky top-0 z-30 p-4 bg-white/85 backdrop-blur-md shadow-sm border-b border-slate-200/70">
            <Dashboard_Header />
          </div>

          {/* Main Dashboard Content */}
          <div className="p-4 md:p-6 lg:p-8">
            {/* Cards Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
              {/* MessageTable Card */}
              {userRole !== "superadmin" && (
                <div className="bg-white/95 rounded-2xl shadow-[0_10px_30px_-15px_rgba(15,23,42,0.25)] border border-slate-200/70 overflow-hidden">
                  <MessageTable />
                </div>
              )}

              {/* ToDoList Card */}
              <div
                className={`bg-white/95 rounded-2xl shadow-[0_10px_30px_-15px_rgba(15,23,42,0.25)] border border-slate-200/70 overflow-hidden ${
                  userRole === "superadmin" ? "lg:col-span-2" : ""
                }`}
              >
                <ToDoList />
              </div>
            </div>

            {/* Calendar Section */}
            <div className="bg-white/95 rounded-2xl shadow-[0_10px_30px_-15px_rgba(15,23,42,0.25)] border border-slate-200/70 overflow-hidden mb-8">
              <Cal reminderFromNotification={reminderFromNotification} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
